<template>
  <el-dialog v-if="dataCollectionUsage && selectedType"
             custom-class="data-collection-select-container dialog-size-middle"
             :title="'「' + selectedColumn.column + '」に紐づけるオープンデータの選択'"
             :top="0"
             :modal="false"
             append-to-body="true"
             :visible.sync="visible"
             @open="$emit('open')"
             @close="$emit('close')"
             @closed="$emit('closed')">
    <field-radio-group v-model="selectedType" name="type_select" :options="typeSelectOptions"
                       @change="val => selectedType = val"></field-radio-group>
    <div class="data-collection-select-container-inner">
      <el-menu class="data-collection-select-navi-container" mode="vertical"
               :default-openeds="dataCollectionUsage[selectedType].map(data => data.dataCollectionId)">
        <el-submenu :index="data.dataCollectionId"
                    v-for="data in getUniqueDataCollection(dataCollectionUsage[selectedType])">
          <template slot="title">
            <span slot="title">{{ data.dataCollectionName }}</span>
          </template>
          <el-menu-item :index="category.categoryId"
                        v-for="category in filterDataCollectionUsage(data.dataCollectionId)"
                        @click="onClickMenuItem(category)">
            <el-checkbox :indeterminate="category.isIndeterminate" class="label-hide" v-model=category.use
                         :key="category.categoryId + '__use'" @change="onChangeCategoryUse(category)"></el-checkbox>
            <span slot="title">{{ category.categoryName || data.dataCollectionName }}</span>
          </el-menu-item>
        </el-submenu>
      </el-menu>
      <div class="data-collection-select-main-container">
        <h2>{{selectedDataCollection ? selectedDataCollection.categoryName ? selectedDataCollection.categoryName :
          selectedDataCollection.dataCollectionName : ''}}</h2>
        <p v-html="selectedDataCollection ? $options.filters.html_format(getDescription(selectedDataCollection)) : ''"></p>
        <p v-if="!selectedDataCollection" style="margin-top: 2em">
          デフォルトでは、データのカテゴリに基づいて出来るだけ多くのデータを紐づける設定となっています。紐づけを行いたくないデータがある場合はチェックボックスで選択して下さい。
        </p>
        <template v-if="selectedDataCollection && hasSubset(selectedDataCollection)">
          <h3 style="margin-top: 2em">使用データ選択</h3>
          <ul style="list-style: none">
            <li v-for="subset in selectedDataCollection.subsets" class="data-collection-select-subset-select">
              <el-checkbox class="label-hide" v-model=subset.use :key="subset.subsetName + '__use'"
                           @change="onChangeSubsetUse(selectedDataCollection)"></el-checkbox>
              <span slot="title"
                    @click="onClickSubset(selectedDataCollection, subset)">{{ subset.subsetName }}&emsp;<span
                      class="title-info">{{ getTitleInfo(subset.subsetColumns) }}</span></span>
            </li>
          </ul>
        </template>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible=false">キャンセル</el-button>
      <el-button type="primary" @click="onClickSelect">OK</el-button>
    </span>
  </el-dialog>

</template>

<script lang="js">
import CommonUtil from '../../../../utils/common'
import LoadingManager from '../../../../utils/loading'
import WebApiClient from '../../../../api/web'
import { DATA_COLLECTION_DEFINES, TYPE_DEFINES, TYPE_ESTIMATE_THRESHOLD } from '../../../../defines/data-collection'
import { DataSourceInfo, Possibility } from '../../../../defines/model/model'

export default {
  name: 'DataCollectionSelectDialogCmp',
  components: {},
  props: {
    selectedColumn: null,
    ds: DataSourceInfo,
    method: '',
    modelId: '',
    modelDataCollectionUsage: [],
    possibility: Possibility
  },
  data () {
    return {
      selectedDataCollection: null,
      visible: true,
      dataCollectionUsage: {},
      selectedType: null,
      typeSelectOptions: []
    }
  },
  computed: {
    searchDataCollectionPromises () {
      // for column name and  first low display
      let searchPromises = []
      const dataCollections = this.dataCollectionUsage[this.selectedType]

      if (CommonUtil.isEmpty(dataCollections)) {
        return null
      } else {
        let targetsCategories = []
        for (let data of dataCollections) {
          if (data.use === true) {
            let searchParam = {
              filters: { 'prefs': ['01000'] }
            }

            if (CommonUtil.isNotEmpty(data.categoryId)) {
              searchParam.categoryId = data.categoryId
            }
            searchPromises.push(WebApiClient.getDataCollection(this, data.dataCollectionId, searchParam))
            targetsCategories.push(data)
          }
        }
        return [searchPromises, targetsCategories]
      }
    }
  },
  created () {
    LoadingManager.show(this)
    // get possible use data collection.
    const types = this.getType(this.possibility)

    const allPossibleDataCollections = DATA_COLLECTION_DEFINES.filter(dataCollection =>
      this.isPossibleAdd(types, dataCollection.dataCollectionId, dataCollection.categoryId)
    )

    // get possible use data collection subsets and columns.
    let promises = []

    for (let data of allPossibleDataCollections) {
      let param = null
      if (CommonUtil.isNotEmpty(data.categoryId)) {
        param = {
          categoryId: data.categoryId
        }
      }
      promises.push(WebApiClient.getDataCollectionSubset(this, data.dataCollectionId, param))
    }

    Promise.all(promises).then(responses => {
      // store result
      responses.forEach((response, index) => {
        allPossibleDataCollections[index].subsets = response.data.result.subsets
      })

      // add info each join type
      types.forEach(type => {
        if (CommonUtil.isEmpty(this.selectedType)) {
          this.selectedType = type.id
        }
        // add data collection
        let dataCollections = []
        type.dataCollections.forEach(useData => {
          const data = DATA_COLLECTION_DEFINES.filter(dataDefine =>
            dataDefine.dataCollectionId === useData.dataCollectionId && dataDefine.categoryId ===
              useData.categoryId)[0]

          dataCollections.push(this.deepCopyDataCollection(data))
        })
        this.dataCollectionUsage[type.id] = Object.assign([], dataCollections)
        // set initial value
        this.InitializeUsage()
      })

      this.typeSelectOptions = this.getTypeOptions()
      LoadingManager.hide(this)
    }).catch(() => {
      LoadingManager.hide(this)
    })
  },
  methods: {
    deepCopyDataCollection (dataCollection) {
      let result = Object.assign({}, dataCollection)
      if (CommonUtil.isNotEmpty(result.subsets)) {
        result.subsets = Object.assign([], result.subsets)
        result.subsets.forEach(subset => {
          subset.subsetColumns = Object.assign([], subset.subsetColumns)
        })
      }
      return result
    },
    isPossibleAdd (types, dataCollectionId, categoryId) {
      let result = false
      types.forEach(type => {
        type.dataCollections.forEach(data => {
          if (data.dataCollectionId === dataCollectionId && data.categoryId === categoryId) {
            result = true
          }
        })
      })
      return result
    },
    getType (possibility) {
      let possibleTypes = []
      Object.keys(possibility).forEach(key => {
        if (key !== 'name' && possibility[key] > TYPE_ESTIMATE_THRESHOLD) {
          possibleTypes.push(key)
        }
      })

      return TYPE_DEFINES.filter(type => possibleTypes.indexOf(type.id) !== -1)
    },
    getTypeOptions () {
      const canUseTypeIds = Object.keys(this.possibility)
        .filter(key => this.possibility[key] > TYPE_ESTIMATE_THRESHOLD)
      let availableTypes = []

      canUseTypeIds.forEach(typeId => {
        const typeDefine = TYPE_DEFINES.filter(define => define.id === typeId)[0]
        availableTypes.push({
          label: typeDefine.name,
          value: typeDefine.id
        })
      })
      return availableTypes
    },
    InitializeUsage () {
      if (CommonUtil.isEmpty(this.modelDataCollectionUsage)) {
        // if user have not already selected value.
        Object.keys(this.dataCollectionUsage).forEach(key => {
          this.dataCollectionUsage[key].forEach(data => {
            data.use = true
            data.isIndeterminate = false
            if (CommonUtil.isNotEmpty(data.subsets)) {
              data.subsets.forEach(subset => {
                subset.use = true
              })
            }
          })
        })
      } else {
        // if user have already selected value.
        Object.keys(this.dataCollectionUsage).forEach(key => {
          this.dataCollectionUsage[key].forEach(data => {
            data.use = this.isUsingDataCollection(data.dataCollectionId, data.categoryId)
            if (data.use === true && CommonUtil.isNotEmpty(data.subsets)) {
              data.subsets.forEach(subset => {
                subset.use = this.isUsingSubset(data.dataCollectionId, data.categoryId, subset.subsetName)
              })
              if (data.subsets.filter(subset => subset.use === true).length > 0 &&
                  data.subsets.filter(subset => subset.use === false).length > 0) {
                data.isIndeterminate = true
              }
            } else if (CommonUtil.isNotEmpty(data.subsets)) {
              data.subsets.forEach(subset => { subset.use = false })
              data.isIndeterminate = false
            }
          })
        })
      }

      this.$forceUpdate()
    },
    getUniqueDataCollection (dataCollectionList) {
      let values = []
      let result = dataCollectionList.filter(data => {
        const value = data.dataCollectionId
        if (values.indexOf(value) === -1) {
          values.push(value)
          return data
        }
      })

      return result
    },

    filterDataCollectionUsage (dataCollectionId) {
      return this.dataCollectionUsage[this.selectedType].filter(data => data.dataCollectionId === dataCollectionId)
    },
    onClickMenuItem (category) {
      this.selectedDataCollection = category
      this.$forceUpdate()
    },
    onClickSubset (category, subset) {
      subset.use = !subset.use
      this.onChangeSubsetUse(category)
    },
    onChangeSubsetUse (category) {
      let [selectedCount, nonSelectedCount] = this.countSubsetUse(category)
      category.isIndeterminate = selectedCount > 0 && nonSelectedCount > 0
      category.use = selectedCount !== 0

      this.$forceUpdate()
    },
    countSubsetUse (category) {
      let selectedCount = 0
      let nonSelectedCount = 0
      category.subsets.forEach(subset => {
        if (subset.use === true) {
          selectedCount++
        } else if (subset.use === false) {
          nonSelectedCount++
        }
      })
      return [selectedCount, nonSelectedCount]
    },
    onChangeCategoryUse (category) {
      if (CommonUtil.isNotEmpty(category.subsets)) {
        let subsetUse = false
        if (category.isIndeterminate || category.use === true) {
          category.use = true
          subsetUse = true
        }

        category.subsets.forEach(subset => {
          subset.use = subsetUse
        })
      }
      category.isIndeterminate = false
      this.$forceUpdate()
    },
    onClickSelect () {
      let [searchPromises, targetsCategories] = this.searchDataCollectionPromises
      Promise.all(searchPromises).then(responses => {
        const searchResponse = responses
        const selectedDataCollection = this.dataCollectionUsage[this.selectedType]

        let excludeColumns = []
        for (let data of selectedDataCollection) {
          data.subsets.forEach(subset => {
            if (subset.use === false) {
              excludeColumns = excludeColumns.concat(subset.subsetColumns)
            }
          })
        }

        searchResponse.forEach((response, index) => {
          let xTypes = []
          response.data.result.columns.forEach(column => {
            if (excludeColumns.indexOf(column.columnName) === -1) {
              xTypes.push({
                name: column.columnName,
                type: column.dataType
              })
            }
          })
          targetsCategories[index].xType = xTypes
        })

        const useDataCollectionList = selectedDataCollection.filter(data => data.use === true)

        this.$emit('select', useDataCollectionList, this.selectedType)
        this.visible = false
      })
    },
    getDropColumnsWithDataChange () {
      // if not current data collection usage info.
      if (CommonUtil.isEmpty(this.modelDataCollectionUsage)) {
        return null
      }

      // if there is current info.
      const useDataCollectionList = this.dataCollectionUsage[this.selectedType].filter(data => data.use === true)

      // get data collection column which used before but not using now.
      const unusedDataCollection = this.modelDataCollectionUsage.filter(modelData => {
        let result = true
        useDataCollectionList.forEach(useData => {
          if (modelData.dataCollectionId === useData.dataCollectionId && modelData.categoryId && useData.categoryId) {
            result = false
          }
        })
        return result
      })
      const unusedDataCollectionColumns = unusedDataCollection.reduce((acc, val) => acc.concat(val.columns), [])
        .reduce((acc, val) => acc.concat(val), [])

        // get data collection column which is using before and now, but there are some using Subset which is not using before.
      const useDataCollectionHasSubset = useDataCollectionList.filter(useData =>
        CommonUtil.isNotEmpty(useData.subsets) &&
          this.isUsingDataCollection(useData.dataCollectionId, useData.categoryId)
      )

      if (CommonUtil.isEmpty(useDataCollectionHasSubset)) { return unusedDataCollectionColumns }

      let unusedSubsetColumns = []
      useDataCollectionHasSubset.forEach(useData => {
        const modelData = this.modelDataCollectionUsage.filter(
          modelData => modelData.dataCollectionId === useData.dataCollectionId && modelData.categoryId &&
              useData.categoryId)[0]
        modelData.subsets.forEach(subsetName => {
          const useDataSubset = useData.subsets.filter(subset => subset.subsetName === subsetName)[0]
          if (useDataSubset.use === false) {
            unusedSubsetColumns = unusedSubsetColumns.concat(useDataSubset.subsetColumns)
          }
        })
      })

      return unusedDataCollectionColumns.concat(unusedSubsetColumns)
    },
    getPrefix (leftOn, dataCollectionName, categoryName = null) {
      let prefix = leftOn + '_' + dataCollectionName
      prefix = CommonUtil.isNotEmpty(categoryName) ? prefix + '_' + categoryName : prefix

      return prefix
    },
    isUsingDataCollection (dataCollectionId, categoryId) {
      if (CommonUtil.isEmpty(this.modelDataCollectionUsage)) {
        return false
      } else {
        const usage = this.modelDataCollectionUsage.filter(modelData =>
          modelData.dataCollectionId === dataCollectionId && modelData.categoryId === categoryId
        )
        return CommonUtil.isNotEmpty(usage)
      }
    },
    isUsingSubset (dataCollectionId, categoryId, subsetName) {
      if (CommonUtil.isEmpty(this.modelDataCollectionUsage)) {
        return false
      } else {
        const targetData = this.modelDataCollectionUsage.filter(modelData =>
          modelData.dataCollectionId === dataCollectionId && modelData.categoryId === categoryId
        )[0]

        const usage = targetData.subsets.filter(subset => subset.indexOf(subsetName) !== -1)

        return CommonUtil.isNotEmpty(usage)
      }
    },
    getJoinDropColumns (dataCollection) {
      const subsets = dataCollection.subsets
      if (CommonUtil.isEmpty(subsets)) {
        return null
      } else {
        let dropColumns = []
        subsets.forEach(subset => {
          if (subset.use !== true) {
            dropColumns = dropColumns.concat(subset.subsetColumns)
          }
        })
        return CommonUtil.isNotEmpty(dropColumns) ? dropColumns : null
      }
    },
    getCurrentDataCollectionUse (currentDataCollection, dataCollectionId, categoryId) {
      let usedDataCollection = null
      if (CommonUtil.isNotEmpty(currentDataCollection)) {
        currentDataCollection.forEach(DataCollection => {
          if (DataCollection.dataCollectionId === dataCollectionId && DataCollection.categoryId === categoryId) {
            usedDataCollection = DataCollection
          }
        })
      }
      return usedDataCollection
    },
    hasSubset (dataCollection) {
      return CommonUtil.isNotEmpty(dataCollection.subsets)
    },
    getTitleInfo (subsetColumns) {
      if (subsetColumns.length > 1) {
        return `(${subsetColumns[0]} など ${subsetColumns.length}項目)`
      } else {
        return `(${subsetColumns.length}項目)`
      }
    },
    getDescription (dataCollection) {
      let description = dataCollection.description
      if (CommonUtil.isNotEmpty(dataCollection.sampleVal)) {
        description = description + '\n' + dataCollection.sampleVal
      }
      return description
    }
  }
}
</script>

<style type="scss" scoped>
  .data-collection-select-container-inner {
    display: flex;
    flex-direction: row;
    height: 470px;
  }

  .data-collection-select-container-inner > .data-collection-select-navi-container {
    flex-shrink: 0;
    width: 330px;
    overflow-y: scroll;
  }

  .data-collection-select-container-inner > .data-collection-select-main-container {
    flex-shrink: 0;
    flex-grow: 1;
    padding-left: 24px;
    max-width: 630px;
    overflow-y: scroll;
  }

  .data-collection-select-container-inner > .data-collection-select-main-container > h2 {
    margin: 0;
  }

  .data-collection-select-container-inner > .data-collection-select-main-container > p {
    margin-top: 0;
    word-wrap: break-word;
  }

  .data-collection-select-container-inner .data-collection-select-subset-select {
    cursor: pointer;
    margin-top: 0.5rem;
  }

  .title-info {
    font-size: 0.88rem;
  }

  .file-upload-content {
    display: none;
  }

</style>



// WEBPACK FOOTER //
// src/components/model/figure/dialogs/data-collection-select.vue